import * as React from 'react';
import { MultiSelect, Select, Input, IconButton } from 'uxp/components';
import { getDefaultAggregation, getInitialAggregation } from './aggregation-utils';
import { IAggregationType } from '@types';
import { QueryBuilderContext } from '@query-builder/QueryBuilderContext';
import './AggregateEditor.scss';
export const AggregateEditor = props => {
    var _a;
    const context = React.useContext(QueryBuilderContext);
    const $L = (key) => context.uxpContext.$L(key);
    const [aggregation, setAggregation] = React.useState(getDefaultAggregation());
    React.useEffect(() => {
        setAggregation(getInitialAggregation(props === null || props === void 0 ? void 0 : props.aggregation));
    }, [props]);
    const handleFieldChange = (index, value) => {
        const newAggregates = [...aggregation.aggregates];
        newAggregates[index].field = value;
        props.onChange(Object.assign(Object.assign({}, aggregation), { aggregates: newAggregates }));
    };
    const handleTypeChange = (index, value) => {
        const newAggregates = [...aggregation.aggregates];
        newAggregates[index].type = value;
        props.onChange(Object.assign(Object.assign({}, aggregation), { aggregates: newAggregates }));
    };
    const handleNameChange = (index, value) => {
        const newAggregates = [...aggregation.aggregates];
        newAggregates[index].name = value;
        props.onChange(Object.assign(Object.assign({}, aggregation), { aggregates: newAggregates }));
    };
    const handleGroupByChange = (values) => {
        props.onChange(Object.assign(Object.assign({}, aggregation), { fields: values }));
    };
    const addAggregation = () => {
        const newAggregation = {
            field: '',
            type: '',
            name: ''
        };
        const newAggregates = [...aggregation.aggregates, newAggregation];
        props.onChange(Object.assign(Object.assign({}, aggregation), { aggregates: newAggregates }));
    };
    const handleRemoveAggregation = (index) => {
        const aggregates = [...aggregation.aggregates];
        aggregates.splice(index, 1);
        props.onChange(Object.assign(Object.assign({}, aggregation), { aggregates: aggregates }));
    };
    return React.createElement("div", { className: "lqe-agg__container-abbd2be7" },
        React.createElement("div", { className: "lqe-agg__conditions-wrap-abbd2be7" },
            ((_a = aggregation.aggregates) === null || _a === void 0 ? void 0 : _a.length) > 0 ? React.createElement("div", { className: "lqe-agg__conditions-abbd2be7" }, aggregation.aggregates.map((agg, i) => React.createElement("div", { className: "lqe-agg__row-abbd2be7", key: i },
                React.createElement("div", { className: "lqe-agg__row-label-abbd2be7" }, i == 0 ? $L('lqe.agg.get-the') : $L('lqe.agg.and')),
                React.createElement("div", { className: "lqe-agg__row-body-abbd2be7" },
                    React.createElement("div", { className: "lqe-agg__input-group-abbd2be7" },
                        React.createElement(Select, { selected: agg.type, onChange: v => handleTypeChange(i, v), options: Object.values(IAggregationType).map(value => ({
                                label: value,
                                value
                            })), className: "lucy-query-engine-input-abbd2be7", dropdownClassname: "lucy-query-engine-dropdown" })),
                    React.createElement("div", { className: "lqe-agg__input-group-abbd2be7" },
                        React.createElement("div", { className: "lqe-agg__input-label-abbd2be7" }, $L('lqe.agg.of')),
                        React.createElement("div", { className: "lqe-agg__input-abbd2be7" },
                            React.createElement(Select, { selected: agg.field, onChange: v => handleFieldChange(i, v), options: (props === null || props === void 0 ? void 0 : props.fields) || [], valueField: 'name', labelField: 'name', className: "lucy-query-engine-input-abbd2be7", dropdownClassname: "lucy-query-engine-dropdown" }))),
                    React.createElement("div", { className: "lqe-agg__input-group-abbd2be7" },
                        React.createElement("div", { className: "lqe-agg__input-label-abbd2be7" }, $L('lqe.agg.as')),
                        React.createElement("div", { className: "lqe-agg__input-abbd2be7" },
                            React.createElement(Input, { value: agg.name || '', onChange: v => handleNameChange(i, v), className: "lucy-query-engine-input-abbd2be7" }))),
                    React.createElement("div", { className: "lqe-agg__delete-wrap-abbd2be7" },
                        React.createElement(IconButton, { type: 'delete', variant: 'danger', onClick: () => handleRemoveAggregation(i) })))))) : React.createElement("div", { className: "lqe-agg__empty-abbd2be7" }, $L('lqe.agg.no-aggregations')),
            React.createElement("div", { className: "lqe-agg__footer-abbd2be7" },
                React.createElement("div", { className: "lqe-agg__add-btn-abbd2be7", onClick: addAggregation }, $L('lqe.agg.add')))),
        React.createElement("div", { className: "lqe-agg__group-by-abbd2be7" },
            React.createElement("div", { className: "lqe-agg__group-by-label-abbd2be7" }, $L('lqe.agg.group-by')),
            React.createElement("div", { className: "lqe-agg__group-by-input-abbd2be7" },
                React.createElement(MultiSelect, { selected: aggregation.fields, onChange: handleGroupByChange, options: (props === null || props === void 0 ? void 0 : props.fields) || [], valueField: 'name', labelField: 'name', className: "lucy-query-engine-input-abbd2be7", dropdownClassname: "lucy-query-engine-dropdown" }))));
};
